import type {Report} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/Report";
import type {CanvasControls} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";
import {hydrateStoredWidgetForFrontend} from "~/domainModels/reports/hydrateStoredWidget";
import type {ReportPage} from "~/domainModels/reports/reportPage";

export type HydratedReport = Omit<Report, "canvasControls" | "pages"> & {
    canvasControls: CanvasControls;
    pages: Array<ReportPage> | null;
};

export function hydrateReportForFrontend(report: Report): HydratedReport {
    return {
        ...report,
        canvasControls: report.canvasControls,
        pages:
            report.pages?.map((page) => ({
                ...page,
                widgets: page.widgets.map((widget) => hydrateStoredWidgetForFrontend(widget)),
            })) ?? null,
    };
}
